import { getSessionToken } from "@/lib/auth";
import { getBrowserIdentity, screenForPath } from "@/lib/deviceIdentity";

const HEARTBEAT_INTERVAL_MS = 10000;

export function createEventSocket(eventId, handlers) {
  const url = new URL(process.env.VUE_APP_WEBSOCKET_URL || "");
  url.searchParams.set("token", getSessionToken());
  url.searchParams.set("eventId", eventId);
  const device = getBrowserIdentity();
  url.searchParams.set("deviceId", device.id);
  url.searchParams.set("deviceKind", device.kind);
  url.searchParams.set("screen", screenForPath(window.location.pathname));
  const socketUrl = url.toString();

  const ws = new WebSocket(socketUrl);
  let heartbeatTimer = null;

  const clearHeartbeat = () => {
    if (heartbeatTimer) {
      window.clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
  };

  const sendHeartbeat = () => {
    if (ws.readyState !== WebSocket.OPEN) {
      return;
    }
    ws.send(JSON.stringify({ action: "heartbeat", eventId }));
  };

  ws.onopen = () => {
    if (handlers?.onOpen) {
      handlers.onOpen(ws);
    }
    ws.send(JSON.stringify({ action: "sendmessage", eventId }));
    sendHeartbeat();
    clearHeartbeat();
    heartbeatTimer = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
  };

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      handlers?.onMessage?.(data);
    } catch (error) {
      handlers?.onError?.(error);
    }
  };

  ws.onerror = (error) => {
    if (handlers?.onError) {
      handlers.onError(error);
    }
  };

  ws.onclose = () => {
    clearHeartbeat();
    if (handlers?.onClose) {
      handlers.onClose();
    }
  };

  return ws;
}
